var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComments = function SvgComments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#comments_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F7F9",
    d: "M5.2 10.4c2.872 0 5.2-1.97 5.2-4.4S8.072 1.6 5.2 1.6 0 3.57 0 6c0 .965.367 1.858.99 2.585a2.3 2.3 0 0 1-.355.617 3 3 0 0 1-.468.47l-.005.005a.4.4 0 0 0-.142.446.41.41 0 0 0 .38.277c.545 0 1.095-.14 1.552-.312.23-.088.446-.185.633-.285.768.38 1.66.597 2.615.597m6-4.4c0 2.807-2.477 4.922-5.412 5.175.607 1.86 2.622 3.225 5.012 3.225a5.9 5.9 0 0 0 2.617-.598c.188.1.4.198.63.286.458.172 1.008.312 1.553.312a.4.4 0 0 0 .235-.725l-.005-.005q-.008-.006-.027-.02a2.867 2.867 0 0 1-.44-.45 2.4 2.4 0 0 1-.355-.618c.622-.725.99-1.617.99-2.585 0-2.32-2.123-4.222-4.815-4.387q.014.191.014.387z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "comments_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgComments;